import { render, staticRenderFns } from "./vTextarea.vue?vue&type=template&id=c273b736&"
import script from "./vTextarea.vue?vue&type=script&lang=js&"
export * from "./vTextarea.vue?vue&type=script&lang=js&"
import style0 from "./vTextarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports